import { t } from "@/i18n-js/instance";
import {
  isCommunityAdmin,
  isCommunityModerator,
} from "@/react/helpers/communityMemberHelpers";
import { settingsPath } from "@/react/helpers/urlHelpers";
import { adminIconsV3 } from "@circle-react/components/Spaces/SidebarV2/LogoTopSection/useAdminIcons";
import { usePunditUserContext } from "@circle-react/contexts";

export const useContentPageLink = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const { contentIcon: icon } = adminIconsV3;

  const isVisible = Boolean(
    isCommunityAdmin(currentCommunityMember) ||
      isCommunityModerator(currentCommunityMember),
  );

  const title = t("settings_nav_v3.content.label");
  const link = settingsPath.files.index();

  return {
    isVisible,
    link,
    icon,
    iconSize: 20,
    title,
  };
};
